import React, { useState, useEffect } from "react";
import { MDBRow, MDBBtnGroup } from "mdb-react-ui-kit";
import axios from "axios";
import Skeleton from "@mui/material/Skeleton";
// config
import configData from "../../../config/config.json";
// components
import RegisterBusinessStep5 from "../../../pages/RegisterBusinessStep5";
import Modal from "../../../components/registerbusiness-s5-modal/Modal";
import AlertSuccess from "../../AlertSuccess/AlertSuccess";

const InformationStep8 = (props) => {
  const [dataCome, setDataCome] = useState(false);
  const [disable, setDisable] = useState(false);

  const [responseLoad, setresponseLoad] = useState({});
  const [responseLoadTT, setresponseLoadTT] = useState(false);
  const [daysHours, setdaysHours] = useState({});

  const [timeData1, setTimeData1] = useState({});
  const [timeData2, setTimeData2] = useState({});
  const [timeData3, setTimeData3] = useState({});
  const [timeData4, setTimeData4] = useState({});
  const [timeData5, setTimeData5] = useState({});
  const [timeData6, setTimeData6] = useState({});
  const [timeData7, setTimeData7] = useState({});

  const [isOnline, setOnline] = useState(false);
  const [isFull, setFull] = useState(false);
  const clickHandler1 = () => {
    setOnline(!isOnline);
  };
  const clickHandler2 = () => {
    setFull(!isFull);
  };
  const [isOpen, setOpen] = useState(false);
  const [isClose, setClose] = useState(false);
  const clickHandler3 = () => {
    if (!isOpen) {
      //false
      setOpen(true);
      setClose(false);
    } else {
      //true
      setOpen(false);
      setClose(false);
    }
  };
  const clickHandler4 = () => {
    if (!isClose) {
      //false
      setClose(true);
      setOpen(false);
    } else {
      //true
      setClose(false);
      setOpen(false);
    }
  };
  const [showAlert, setshowAlert] = useState(false);
  const alertHandeler = () => {
    setshowAlert(true);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setshowAlert(false);
    }, 4000);
  };

  useEffect(() => {
    setDataCome(false);
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else {
      axios
        .get(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/workTimes`, // the business Guuid that gets from login
          {
            headers: {
              ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
              LangId: 1,
              Authorization: "Bearer " + getCookie("token"),
            },
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            // success
            let data = response.data.data;

            setClose(!data.holidayStatus);
            setOpen(data.holidayStatus);
            setOnline(data.isOnline);
            setFull(data.open24Hours);
            setdaysHours(data.hours);
            setresponseLoad(data.days);
            setresponseLoadTT(true);

            setDataCome(true);
          }
        })
        .catch((error) => {
          alert(error);
        });

      // load api by aidin
      // axios
      //   .get(domain + "/api/biz/work-time", {
      //     headers: {
      //       ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
      //       LangId: 1,
      //       BizId: getCookie("BizId"),
      //     },
      //   })
      //   .then((response) => {
      //     if ((response.data.msg = "done")) {
      //       setDataCome(true);

      //       setClose(!response.data.HolidayStatus);
      //       setOpen(response.data.HolidayStatus);
      //       setOnline(response.data.IsOnline);
      //       setFull(response.data.Open24Hours);
      //       setdaysHours(response.data.Hours);
      //       setresponseLoad(response.data.Days);
      //       setresponseLoadTT(true);
      //     }
      //   })
      //   .catch((error) => {
      //     // alert(error);
      //   });
    }
  }, []);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const submitHandler = (event) => {
    event.preventDefault();
    setDisable(true);

    const dataPost = {
      bId: getCookie("BizId"),
      isOnline: isOnline,
      open24Hours: isFull,
      holidayStatus: isOpen,
      workHours: responseLoad,
    };

    axios
      .post(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/workTimes`,
        dataPost,
        {
          headers: {
            ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
            LangId: 1,
            Authorization: "Bearer " + getCookie("token"),
          },
        }
      )
      .then((response) => {
        setDisable(false);
        if (response.data.isSuccess) {
          // success
          alertHandeler();
        }
      })
      .catch((error) => {
        // alert(error);
      });

    // save api by aidin
    // axios
    //   .post(domain + "/api/biz/work-time-update", dataPost, {
    //     headers: {
    //       ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    //       LangId: 1,
    //       BizId: getCookie("BizId"),
    //     },
    //   })
    //   .then((response) => {
    //     setDisable(false);
    //     if (response.data.msg == "done") {
    //       // success
    //       alertHandeler();
    //     }
    //   })
    //   .catch((error) => {
    //     // alert(error);
    //   });
  };

  return (
    <>
      <div className="part_eight_info">
        <div className="step3_header"></div>
        <MDBRow className="mx-0 t_a_l_c">
          <div className="col-12 p-0">
            <div className="">
              {dataCome ? (
                <div className="rb-s5-group2-buiness d-block d-md-flex center-resp">
                  <button
                    className={
                      isOnline
                        ? "rb-s5-group2-btn-on"
                        : "rb-s5-group2-btn-off dash-bus"
                    }
                    onClick={clickHandler1}
                  >
                    کسب‌و‌کار آنلاین است
                  </button>
                  <button
                    className={
                      isFull
                        ? "rb-s5-group2-btn-on"
                        : "rb-s5-group2-btn-off dash-bus"
                    }
                    onClick={clickHandler2}
                  >
                    کسب‌و‌کار شبانه‌روزی است
                  </button>
                </div>
              ) : (
                <div className="rb-s5-group2-buiness d-block d-md-flex center-resp">
                  <Skeleton
                    className="bg-skeleton border-0 rb-s5-group2-btn-off "
                    variant="rectangular"
                    height={41.5}
                    animation="wave"
                  />{" "}
                  <Skeleton
                    className="bg-skeleton border-0 rb-s5-group2-btn-off"
                    variant="rectangular"
                    height={41.5}
                    animation="wave"
                  />
                </div>
              )}

              {dataCome ? (
                <div className="">
                  {/* <Modal dashBus={true} /> */}
                  {responseLoadTT && (
                    <Modal
                      dashBus={true}
                      // responseLoadTT={responseLoadTT}
                      // setresponseLoadTT={setresponseLoadTT}
                      isFull={isFull}
                      daysHours={daysHours}
                      responseLoad={responseLoad}
                      setresponseLoad={setresponseLoad}
                      timeData1={timeData1}
                      setTimeData1={setTimeData1}
                      timeData2={timeData2}
                      setTimeData2={setTimeData2}
                      timeData3={timeData3}
                      setTimeData3={setTimeData3}
                      timeData4={timeData4}
                      setTimeData4={setTimeData4}
                      timeData5={timeData5}
                      setTimeData5={setTimeData5}
                      timeData6={timeData6}
                      setTimeData6={setTimeData6}
                      timeData7={timeData7}
                      setTimeData7={setTimeData7}
                    />
                  )}
                </div>
              ) : (
                <Skeleton
                  className="bg-skeleton border-0 s5-modal-btn mx-auto"
                  variant="rectangular"
                  height={50.7}
                  animation="wave"
                />
              )}

              <p className="rb-step5-tit2">تعطیلات رسمی دولتی:</p>
              {dataCome ? (
                <MDBBtnGroup className="rb-s5-group2-buiness d-block d-md-flex center-resp">
                  <button
                    className={
                      isClose
                        ? "rb-s5-group-btn-on mb-3"
                        : "rb-s5-group-btn-off dash-bus mb-3"
                    }
                    onClick={clickHandler4}
                  >
                    بسته است
                  </button>
                  <button
                    className={
                      isOpen
                        ? "rb-s5-group-btn-on mb-3"
                        : "rb-s5-group-btn-off dash-bus mb-3"
                    }
                    onClick={clickHandler3}
                  >
                    باز است
                  </button>
                </MDBBtnGroup>
              ) : (
                <div className="rb-s5-group2-buiness d-block d-md-flex center-resp">
                  <Skeleton
                    className="bg-skeleton border-0 rb-s5-group-btn-off mb-3"
                    variant="rectangular"
                    height={40.5}
                    animation="wave"
                  />{" "}
                  <Skeleton
                    className="bg-skeleton border-0 rb-s5-group-btn-off"
                    variant="rectangular"
                    height={40.5}
                    animation="wave"
                  />
                </div>
              )}
            </div>
          </div>
        </MDBRow>
        <div className="step2_save_c p-0">
          {dataCome ? (
            <button
              onClick={submitHandler}
              disabled={disable}
              className="btn_information_submit"
            >
              ذخیره اطلاعات
            </button>
          ) : (
            <Skeleton
              className="btn_information_submit me-auto"
              variant="rectangular"
              height={39}
              animation="wave"
            />
          )}
        </div>
        {/* alert delete */}
        <AlertSuccess
          showAlert={showAlert}
          text={" اطلاعات شما با موفقیت ثبت شد."}
        />
      </div>
    </>
  );
};

export default InformationStep8;
